import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  Input,
  OnChanges,
  SimpleChanges,
  inject
} from '@angular/core';
import { GetImageWithGidService } from '@coin/shared/auth/data-access';
import { take } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { LegalEntityManagement } from '../../../api/generated';
import { NgStyle, UpperCasePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { NamePipe } from '../../pipes/name.pipe';
import { V2CountryFlagComponent } from '@coin/shared/core/ui-storybook';

@Component({
  selector: 'cosmos-manager-preview',
  templateUrl: './manager-preview.component.html',
  styleUrls: ['./manager-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgStyle, MatIcon, V2CountryFlagComponent, UpperCasePipe, NamePipe]
})
export class ManagerPreviewComponent implements OnChanges {
  private readonly imageService = inject(GetImageWithGidService);
  private readonly cdr = inject(ChangeDetectorRef);
  private readonly destroyRef = inject(DestroyRef);

  @Input() manager: LegalEntityManagement;
  @Input() position: string;

  public userImageSrc: string;

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.manager && changes.manager.previousValue?.gid !== changes.manager.currentValue?.gid) {
      this.loadUserImage();
    }
  }

  private loadUserImage(): void {
    this.userImageSrc = undefined;

    if (this.manager) {
      this.imageService
        .getImageWithStore(this.manager.gid)
        .pipe(take(1))
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe(imgSrc => {
          this.userImageSrc = imgSrc;
          this.cdr.detectChanges();
        });
    }
  }
}
